const isParentPage = ( currentPath, parentPath ) => {
    const availablePaths = [
        `/${parentPath}/`,
        `/${parentPath}`
    ]
    return availablePaths.includes(currentPath)
}

export default function( currentPath, parentRoute, previousRoute ) {
    previousRoute = previousRoute || {
        path: 'discover-your-story',
        label: 'Back to Discover Your Story'
    }

    const backRoute = isParentPage(currentPath, parentRoute.path) 
        ? `/${previousRoute.path}` 
        : `/${parentRoute.path}/`

    const backLabel = isParentPage(currentPath, parentRoute.path) 
        ? previousRoute.label
        : parentRoute.label
    
    return {
        backRoute,
        backLabel,
    }
}
